import { render } from "./ColumnUi.vue?vue&type=template&id=4ec534d5&scoped=true"
import script from "./ColumnUi.vue?vue&type=script&lang=js"
export * from "./ColumnUi.vue?vue&type=script&lang=js"

import "./ColumnUi.vue?vue&type=style&index=0&id=4ec534d5&lang=scss&scoped=true"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec534d5"]])

export default __exports__